import { Component, OnInit, Input, OnDestroy, Inject, HostListener } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { HttpclientService } from 'src/app/admin/core/services/httpclientService';
import { ViewService } from 'src/app/admin/core/services/viewservice';
import { DynamicDocumentFieldInfoType } from 'src/app/shared/entities/dynamic-document';
import { Tables } from 'src/app/shared/entities/tables';
import { CustomTranslateService } from 'src/app/shared/services/custom-translate.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-filtrer-champ',
  templateUrl: './filtrer-champ.component.html',
  styleUrls: ['./filtrer-champ.component.css'],
})
export class FiltrerChampComponent implements OnInit, OnDestroy {
  @Input()
  public tab: Tables = new Tables();

  private typeCondition: string;

  private choixConditionsParType: { [key: string]: any[] };

  public choixConditions: any[];

  public conditions: any[] = [];

  public peuxEffacerRecherche: boolean = false;

  public parameters: any[] = [];

  public isParameterField: boolean = false;

  public isMultipleParameterField: boolean = false;

  get isDate(): boolean {
    return this.typeCondition === 'DATE';
  }

  get isBoolean(): boolean {
    return this.typeCondition === 'BOOLEAN';
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialog: MatDialogRef<any>,
    private viewService: ViewService,
    private translateService: CustomTranslateService,
    private httpclientService: HttpclientService
  ) { }

  public ngOnInit(): void {
    this.choixConditionsParType = this.viewService.filterConditions();
    this.typeCondition = this.tab.champType;

    this.choixConditions = this.choixConditionsParType[this.typeCondition];

    const conditionDefaut = this.choixConditions[0];

    if (this.tab.isDynamic) {
      this.httpclientService
        .get(`dynamic-document-infos/${this.tab.entite}/${this.tab.champ}`)
        .subscribe((references) => {
          let locale = environment.languages.find(
            (l) => l.code === this.translateService.currentLang
          )?.locale;

          if (references !== null && references.length > 0) {
            this.isParameterField = true;
            this.isMultipleParameterField = false;

            this.parameters = references
              .filter((reference: any) => reference['valeur'] !== undefined)
              .map((reference: any) => {
                return {
                  // valeur: reference['mapLocalLibelle'][locale ? locale : 'fr_FR'],
                  valeur: reference['mapLocalLibelle']['fr_FR'], // On va regarder ca apres le demo
                  value: reference['valeur'],
                };
              });
          } else {
            if (this.typeCondition === DynamicDocumentFieldInfoType.PARAMETER_LINKS && this.tab.nomTableField) {
              this.httpclientService
                .get(`parametre/nomtable/${this.tab.nomTableField}`)
                .subscribe((references) => {
                  if (references !== null && references.length > 0) {
                    this.isParameterField = true;
                    this.isMultipleParameterField = true;

                    this.parameters = references
                      .filter((reference: any) => reference['valeur'] !== undefined)
                      .map((reference: any) => {
                        return {
                          valeur: reference['mapLocalLibelle']['fr_FR'],
                          value: reference['valeur'],
                        };
                      });
                  }
                });
            }
          }
          if (this.tab.filter === undefined || this.tab.filter === null) {
            this.conditions.pop();
            this.conditions.push({
              id: this.conditions.length,
              type: this.typeCondition,
              condition: conditionDefaut.value,
              valeur: this.parameters[0]?.valeur ?? this.parameters[0]?.value,
              valeurMin: '',
              value: this.parameters[0]?.value,
              valeurMax: '',
            });
          }
        });
    }
    if (this.tab.filter === undefined || this.tab.filter === null) {
      //on defini contient comme condition par defaut grâce l'index 0

      // OLD CODE : TO BE REMOVE
      // this.conditions.push({
      //   id: this.conditions.length,
      //   type: this.typeCondition,
      //   condition: conditionDefaut.value,
      //   valeur: '',
      //   value: '',
      //   valeurMin: '',
      //   valeurMax: '',
      // });

      if (this.typeCondition === 'DATE') {
        // Add like this for the exporter to work
        this.conditions.push({
          type: this.typeCondition,
          condition: conditionDefaut.value,
          valeurMin: '',
          valeurMax: '',
        });
      } else {
        this.conditions.push({
          id: this.conditions.length,
          type: this.typeCondition,
          condition: conditionDefaut.value,
          valeur: '',
          value: '',
          valeurMin: '',
          valeurMax: '',
        });
      }
    } else {
      for (let condition of this.tab.filter?.conditions) {
        this.conditions.push({
          id: this.conditions.length,
          type: condition.type,
          condition: condition.condition ?? condition.type,
          valeur: condition.valeur ?? condition.value,
          value: condition.value ?? condition.valeur,
          valeurMin: condition.valeurMin,
          valeurMax: condition.valeurMax,
        });
      }
      this.peuxEffacerRecherche = true;
    }

    if (!this.tab.isDynamic) {
      this.staticReferences();
    }
  }
  public ngOnChanges(): void { }

  public ngOnDestroy(): void { }

  updateConditionValue(condition: any, value: any): void {
    condition.value = value;
    condition.valeur = value;
  }

  staticReferences() {
    this.httpclientService
      .get(`view/references/${this.tab.entite}/${this.tab.champ}`)
      .subscribe((references) => {
        if (references !== null && references.length > 0) {
          this.isParameterField = true;

          this.parameters = references
            .filter((reference: any) => reference['valeur'] !== undefined)
            .map((reference: any) => reference['valeur']);

          if (this.tab.filter === undefined || this.tab.filter === null) {
            const conditionDefaut = this.choixConditions[0];

            this.conditions.pop();
            this.conditions.push({
              id: this.conditions.length,
              type: this.typeCondition,
              condition: conditionDefaut.value,
              valeur: this.parameters[0],
              value: this.parameters[0],
              valeurMin: '',
              valeurMax: '',
            });
          }
        } else {
          this.isParameterField = false;
        }
      });
  }

  public fermer(): void {
    this.dialog.close();
  }

  public ajouterCondition(): void {
    const conditionDefaut = this.choixConditions[0];

    this.conditions.push({
      id: this.conditions.length,
      type: this.typeCondition,
      condition: conditionDefaut.value,
      valeur: '',
      value: '',
      valeurMin: '',
      valeurMax: '',
    });
  }

  public supprimerCondition(id: number): void {
    const condition = this.conditions.find((t) => t.id === id);
    if (condition !== undefined) {
      this.conditions.splice(this.conditions.indexOf(condition), 1);
    }

    if (this.conditions.length === 0) {
      this.ajouterCondition();
    }
  }

  isDateParameter(parameter: string): boolean {
    // Add logic to check if the parameter is a date
    return true; // Modify this based on your conditions
  }

  public rechercher(): void {
    this.conditions.forEach(condition => {
      if (this.typeCondition === 'DATE') {
        if (condition.condition === 'BETWEEN') {
          condition.valeur = null;
        } else {
          condition.valeurMin = null;
          condition.valeurMax = null;
        }
      } else if (this.typeCondition === 'NUMBER') {
        if (condition.condition === 'BETWEEN') {
          condition.valeur = null;
          condition.valeurMin = Number(condition?.valeurMin);
          condition.valeurMax = Number(condition?.valeurMax);
        } else {
          condition.value = Number(condition?.value);
          condition.valeurMin = null;
          condition.valeurMax = null;
        }
      }
    });

    if (this.conditions.length > 0) {
      this.dialog.close({
        champ: this.tab.champ === 'téléphone' ? 'tels' : this.tab.champ,
        conditions: this.conditions,
        defaultValue: false,
      });
    } else {
      this.dialog.close(null);
    }
  }

  public effacerRecherche(): void {
    this.dialog.close(null);
  }

  public boutonrechercherdesactive(): boolean {
    if (this.conditions.length > 0) {
      for (const condition of this.conditions) {
        if (condition.condition === '') {
          return true;
        }
        if (condition.condition === 'BETWEEN') {
          if (condition.valeurMin === '' || condition.valeurMax === '') {
            return true;
          }
        }
        if (
          condition.condition !== 'BETWEEN' &&
          condition.condition !== 'IS_EMPTY' &&
          condition.condition !== 'IS_NOT_EMPTY'
        ) {
          // if (condition.valeur === '') {
          //   return true;
          // }
          if (condition.value === '' && condition.valeur == '') {
            return true;
          }
        }
      }
    }
    return false;
  }

  /**
   * Xử lý phím Enter để áp dụng bộ lọc
   * Chỉ áp dụng khi nút RECHERCHER không bị disable
   */
  @HostListener('keydown.enter', ['$event'])
  onEnterKeyDown(event: KeyboardEvent): void {
    // Kiểm tra nếu đang focus vào textarea hoặc select đang mở thì không xử lý
    const target = event.target as HTMLElement;
    if (target.tagName === 'TEXTAREA' || target.closest('.mat-select-panel')) {
      return;
    }

    // Ngăn chặn hành vi mặc định (submit form)
    event.preventDefault();
    event.stopPropagation();

    // Chỉ áp dụng filter nếu nút không bị disable
    if (!this.boutonrechercherdesactive()) {
      this.rechercher();
    }
  }
}
